export const projectActions = {
    GET_NEW_PROJECT: 'GET_NEW_PROJECT',
    SET_NEW_PROJECT: 'SET_NEW_PROJECT',
    UPDATE_PROJECT: 'UPDATE_PROJECT',
    GET_PROJECT: 'GET_PROJECT',
    SET_PROJECT: 'SET_PROJECT',
    GET_PROJECT_ENUMS: 'GET_PROJECT_ENUMS',
    SET_PROJECT_ENUMS: 'SET_PROJECT_ENUMS',
    GET_PROJECT_TEMPLATES: 'GET_PROJECT_TEMPLATES',
    SET_PROJECT_TEMPLATES: 'SET_PROJECT_TEMPLATES',
    GET_PROJECT_ENV_TYPES: 'GET_PROJECT_ENV_TYPES',
    SET_PROJECT_ENV_TYPES: 'SET_PROJECT_ENV_TYPES',
    GET_AVAILABLE_SCHEMAS: 'GET_AVAILABLE_SCHEMAS',
    ASSIGN_SCHEMA: 'ASSIGN_SCHEMA',
    GET_HOSTS: 'GET_HOSTS',
    SET_HOSTS: 'SET_HOSTS',
    GET_COMPARISON_TYPES: 'GET_COMPARISON_TYPES',
    GET_BASELINE_TYPES: 'GET_BASELINE_TYPES',
    SET_PROJECT_DATA: 'SET_PROJECT_DATA',
    SAVE_DRAFT: 'SAVE_DRAFT',
    ADD_UNAMANGED_SCHEMAS: 'ADD_UNAMANGED_SCHEMAS',
    COMMIT_PROJECT: 'COMMIT_PROJECT',
    GET_PUBLISH_STATUS: 'GET_PUBLISH_STATUS',
    GET_EDIT_PROJECT: 'GET_EDIT_PROJECT',
    SET_EDIT_PROJECT: 'SET_EDIT_PROJECT',
    GET_IMPACT_ANALYSIS_INIT: 'GET_IMPACT_ANALYSIS_INIT',
    GET_IMPACT_ANALYSIS_VIEW_CHANGES: 'GET_IMPACT_ANALYSIS_VIEW_CHANGES',
    UPDATE_IMPACT_ANALYSIS_FILTERS: 'UPDATE_IMPACT_ANALYSIS_FILTERS',
    UPDATE_IMPACT_ANALYSIS_MAIN_ACTIONS: 'UPDATE_IMPACT_ANALYSIS_MAIN_ACTIONS',
    GET_MAIN_SCRIPTS_SOURCE_PATH: 'GET_MAIN_SCRIPTS_SOURCE_PATH', // TODO delete it
    SET_MAIN_SCRIPTS_SOURCE_PATH: 'SET_MAIN_SCRIPTS_SOURCE_PATH', // TODO delete it
    GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS: 'GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS',
    RECEIVED_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS: 'RECEIVED_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS',
    GET_IS_PROJECT_EXISTS: 'GET_IS_PROJECT_EXISTS',
    SET_IS_PROJECT_EXISTS: 'SET_IS_PROJECT_EXISTS',
    GET_RS_SCHEMES: 'GET_RS_SCHEMES',
    SET_EDIT_MODE: 'SET_EDIT_MODE',
    HIDE_MANAGE_ENVIRONMENT_ON_EDIT_MODE: 'HIDE_MANAGE_ENVIRONMENT_ON_EDIT_MODE',
    SAVE_PROJECT_BEFORE_EDIT: 'SAVE_PROJECT_BEFORE_EDIT',
    ACTION_CLICK: 'ACTION_CLICK',
    ACTION_CLEAR: 'ACTION_CLEAR',
    GET_ADDITIONAL_OPTIONS: 'GET_ADDITIONAL_OPTIONS',
    SET_ADDITIONAL_OPTIONS: 'SET_ADDITIONAL_OPTIONS',
    IS_RM_MANAGE_BY_DBTYPE: 'IS_RM_MANAGE_BY_DBTYPE',
    GET_DB_TYPE_FLAGS: 'GET_DB_TYPE_FLAGS',
    SET_DB_TYPE_FLAGS: 'SET_DB_TYPE_FLAGS',
    GET_DB_TYPE_IMAGE: 'GET_DB_TYPE_IMAGE',
    SET_DB_TYPE_IMAGE: 'SET_DB_TYPE_IMAGE',
    RESET_IMPACT_ANALYSIS_DATA: 'RESET_IMPACT_ANALYSIS_DATA',
    RESET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS: 'RESET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS',
    RESET_ENV_TYPES: 'RESET_ENV_TYPES',
    RESET_SCHEMAS_LIST: 'RESET_SCHEMAS_LIST',
    RESET_AVAILABLE_SCHEMAS_LIST: 'RESET_AVAILABLE_SCHEMAS_LIST',
    SET_FILTERED_SELECTION_PACKAGES: 'SET_FILTERED_SELECTION_PACKAGES',
    REMOVE_PROJECT_DATA: 'REMOVE_PROJECT_DATA',
    REMOVE_PROJECT_BEFORE_EDIT: 'REMOVE_PROJECT_BEFORE_EDIT',

    GET_EXCLUDE_OBJECTS: 'GET_EXCLUDE_OBJECTS',
    GET_RM_SCHEMAS: 'GET_RM_SCHEMAS',
    GET_RM_SCHEMAS_EXTENDED: 'GET_RM_SCHEMAS_EXTENDED',
    UPDATE_EXCLUDE_OBJECTS: 'UPDATE_EXCLUDE_OBJECTS',

    GET_STATIC_CONTENT: 'GET_STATIC_CONTENT',
    UPDATE_STATIC_CONTENT: 'UPDATE_STATIC_CONTENT',

    GET_DATABASE_TABLES_AND_U_INDEXES: 'GET_DATABASE_TABLES_AND_U_INDEXES',

    GET_SYSTEM_PRE_DEFINED:'GET_SYSTEM_PRE_DEFINED',
    GET_USER_DEFINED:'GET_USER_DEFINED',
    SET_PROJECT_VARIABLES:'SET_PROJECT_VERIABLES',
    TEST_SOURCE_CONTROL_FOLDER:'TEST_SOURCE_CONTROL_FOLDER',

    GET_FILE_EXTENSIONS: 'GET_FILE_EXTENSIONS'
};

const initState = {
    isProjectExists: false,
    availableSchemas: [],
    comparisonTypes: [],
    baselineTypes: [],
    projectEnvTypesWithEnvsAndDeployStatus: null,
    mainScriptsSourcePath: null,
    impact_analysis: null,
    impact_analysis_script: null,
    dbTypeImages: undefined,
    dbTypeFlags: undefined,
    filteredSelectionPackages: undefined
};

export const projectReducer = (state = initState, action: any) => {
    switch (action.type) {
        case projectActions.SET_DB_TYPE_IMAGE:
            return { ...state, dbTypeImages: { ...state.dbTypeImages, ...action.payload } };

        case projectActions.SET_DB_TYPE_FLAGS:
            return { ...state, dbTypeFlags: { ...state.dbTypeFlags, ...action.payload } };

        case projectActions.SET_ADDITIONAL_OPTIONS:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_IMPACT_ANALYSIS_INIT:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_IMPACT_ANALYSIS_VIEW_CHANGES:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_IS_PROJECT_EXISTS:
            return Object.assign({}, state, action.payload);
        case projectActions.SET_IS_PROJECT_EXISTS:
            return Object.assign({}, state, action.payload );

        case projectActions.UPDATE_IMPACT_ANALYSIS_FILTERS:
            return Object.assign({}, state, action.payload);

        case projectActions.UPDATE_IMPACT_ANALYSIS_MAIN_ACTIONS:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_NEW_PROJECT:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_PROJECT:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_PROJECT_TEMPLATES:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_PROJECT_ENV_TYPES:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_PROJECT_ENUMS:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_PROJECT_DATA:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_EDIT_PROJECT:
        case projectActions.SET_MAIN_SCRIPTS_SOURCE_PATH:
            return Object.assign({}, state, action.payload);

        case projectActions.RECEIVED_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_EDIT_MODE:
            if (!action.payload.editMode) {
                return Object.assign({}, state, { editMode: action.payload.editMode, hideManageEnv: false });
            }
            return Object.assign({}, state, action.payload);

        case projectActions.HIDE_MANAGE_ENVIRONMENT_ON_EDIT_MODE:
            return Object.assign({}, state, action.payload);

        case projectActions.SAVE_PROJECT_BEFORE_EDIT:
            return Object.assign({}, state, { projectBeforeEdit: action.payload });

        case projectActions.ACTION_CLICK:
            return Object.assign({}, state, { editActions: action.payload });

        case projectActions.ACTION_CLEAR:
            return Object.assign({}, state, { editActions: null });

        case projectActions.RESET_IMPACT_ANALYSIS_DATA:
            return Object.assign({}, state, { impact_analysis: null });

        case projectActions.RESET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS:
            return Object.assign({}, state, { projectEnvTypesWithEnvsAndDeployStatus: null });

        case projectActions.RESET_ENV_TYPES:
            return Object.assign({}, state, { environmentTypes: [] });

        case projectActions.SET_FILTERED_SELECTION_PACKAGES:
            return { ...state, filteredSelectionPackages: { ...state.filteredSelectionPackages, ...action.payload } };

        case projectActions.RESET_SCHEMAS_LIST:
            return Object.assign({}, state, { schemas: null });

        case projectActions.RESET_AVAILABLE_SCHEMAS_LIST:
            return Object.assign({}, state, { availableSchemas: null });

        case projectActions.REMOVE_PROJECT_DATA:
            return Object.assign({}, state, { data: null });

        case projectActions.REMOVE_PROJECT_BEFORE_EDIT:
            return Object.assign({}, state, { projectBeforeEdit: null });

        case projectActions.GET_EXCLUDE_OBJECTS:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_RM_SCHEMAS:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_RM_SCHEMAS_EXTENDED:
            return Object.assign({}, state, action.payload);

        case projectActions.UPDATE_EXCLUDE_OBJECTS:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_STATIC_CONTENT:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_DATABASE_TABLES_AND_U_INDEXES:
            return Object.assign({}, state, action.payload);

        case projectActions.UPDATE_STATIC_CONTENT:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_SYSTEM_PRE_DEFINED:
            return Object.assign({}, state, action.payload);

        case projectActions.GET_USER_DEFINED:
            return Object.assign({}, state, action.payload);

        case projectActions.SET_PROJECT_VARIABLES:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/projectReducer.ts